import type { Path } from 'react-hook-form'

import { AutomaticPaymentRemindersType } from '../../../../../enums/automaticPaymentRemindersType'
import type { PaymentsAndRemindersSettingsFormValues } from '../../../types/paymentsAndRemindersSettingsFormValues'

interface AutomaticPaymentRemindersRowFieldPaths {
  active: Path<PaymentsAndRemindersSettingsFormValues>
  nDays: Path<PaymentsAndRemindersSettingsFormValues>
}

export const automaticPaymentRemindersRowFieldPathsByType: Record<
  AutomaticPaymentRemindersType,
  AutomaticPaymentRemindersRowFieldPaths
> = {
  [AutomaticPaymentRemindersType.AfterDueDate]: {
    active: 'automaticPaymentRemindersSettings.afterDueDate.active',
    nDays: 'automaticPaymentRemindersSettings.afterDueDate.nDays',
  },
  [AutomaticPaymentRemindersType.BeforeDueDate]: {
    active: 'automaticPaymentRemindersSettings.beforeDueDate.active',
    nDays: 'automaticPaymentRemindersSettings.beforeDueDate.nDays',
  },
  [AutomaticPaymentRemindersType.OnDueDate]: {
    active: 'automaticPaymentRemindersSettings.onDueDate.active',
    nDays: 'automaticPaymentRemindersSettings.onDueDate.nDays',
  },
}
